import * as React from 'react';
import { ContactPropertiesIcon, FormsIcon, ListsIcon, MergeIcon, RegistrationIcon, WorkflowsIcon, DynamicFilterIcon, ObjectAssociationsIcon } from 'foundations-assets';
import EnrollmentTimelineItemIcon from 'flow-doctor-lib/components/timeline/EnrollmentTimelineItemIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const TimelineItemIcon = props => {
  const {
    logItem,
    defaultIcon,
    className,
    size = '200'
  } = props;
  switch (logItem.type) {
    case 'ENROLLMENT_LOG_EVENT':
      {
        return /*#__PURE__*/_jsx(EnrollmentTimelineItemIcon, {
          logItem: logItem,
          defaultIcon: defaultIcon,
          size: size
        });
      }
    case 'PROPERTY_CHANGE':
      return /*#__PURE__*/React.cloneElement(defaultIcon, {
        icon: ContactPropertiesIcon,
        backgroundColor: 'icon-core-subtle',
        borderColor: 'border-core-hover',
        color: 'icon-primary-on-fill-default',
        size,
        className
      });
    case 'FORM_SUBMISSION':
      return /*#__PURE__*/React.cloneElement(defaultIcon, {
        icon: FormsIcon,
        backgroundColor: 'fill-accent-light-orange-default',
        borderColor: 'fill-accent-light-orange-default',
        color: 'icon-primary-on-fill-default',
        size,
        className
      });
    case 'LIST_MEMBERSHIP':
      return /*#__PURE__*/React.cloneElement(defaultIcon, {
        icon: ListsIcon,
        backgroundColor: 'fill-accent-magenta-default',
        borderColor: 'fill-accent-magenta-default',
        color: 'icon-primary-on-fill-default',
        size,
        className
      });
    case 'LIST_MEMBERSHIP_WITH_VISIBILITY':
      return /*#__PURE__*/React.cloneElement(defaultIcon, {
        icon: ListsIcon,
        backgroundColor: 'fill-accent-magenta-default',
        borderColor: 'fill-accent-magenta-default',
        color: 'icon-primary-on-fill-default',
        size,
        className
      });
    case 'OBJECT_MERGE':
      return /*#__PURE__*/React.cloneElement(defaultIcon, {
        icon: MergeIcon,
        backgroundColor: 'fill-accent-purple-default',
        borderColor: 'fill-accent-purple-default',
        color: 'icon-primary-on-fill-default',
        size,
        className
      });
    case 'FLOW_REVISION':
      return /*#__PURE__*/React.cloneElement(defaultIcon, {
        icon: RegistrationIcon,
        backgroundColor: 'fill-accent-blue-hover',
        borderColor: 'fill-accent-blue-hover',
        color: 'icon-primary-on-fill-default',
        size,
        className
      });
    case 'UNIFIED_EVENT':
      return /*#__PURE__*/React.cloneElement(defaultIcon, {
        icon: DynamicFilterIcon,
        backgroundColor: 'fill-accent-light-orange-default',
        borderColor: 'fill-accent-light-orange-default',
        color: 'icon-primary-on-fill-default',
        size,
        className
      });
    case 'ACTION_EXECUTION_LOG_EVENT':
      return /*#__PURE__*/React.cloneElement(defaultIcon, {
        icon: WorkflowsIcon,
        backgroundColor: 'fill-accent-light-orange-default',
        borderColor: 'fill-accent-light-orange-default',
        color: 'icon-primary-on-fill-default',
        size,
        className
      });
    case 'ASSOCIATION_PROPERTY_CHANGE':
      return /*#__PURE__*/React.cloneElement(defaultIcon, {
        icon: ContactPropertiesIcon,
        backgroundColor: 'icon-primary-disabled',
        borderColor: 'icon-primary-disabled',
        color: 'icon-primary-on-fill-default',
        size,
        className
      });
    case 'ASSOCIATION_CHANGE':
      return /*#__PURE__*/React.cloneElement(defaultIcon, {
        icon: ObjectAssociationsIcon,
        backgroundColor: 'fill-accent-purple-default',
        borderColor: 'fill-accent-purple-default',
        color: 'icon-primary-on-fill-default',
        size,
        className
      });
    default:
      throw new Error(`Unrecognized TimelineLogItem type ${logItem.type}. Please add it`);
  }
};
export default TimelineItemIcon;